import React from 'react';
import { useNavigate } from 'react-router-dom';
import employee from '../class/employee';

// Menu operazioni del magazziniere. L'accesso è già garantito da RequireQualifica.
const TILES = [
    { to: '/prelievo', icon: 'fa-hand-paper-o', label: 'Prelievo' },
    { to: '/rientro', icon: 'fa-undo', label: 'Rientro Avanzi' },
    { to: '/posizionamento', icon: 'fa-plus-square-o', label: 'Posizionamento' },
    { to: '/correzione', icon: 'fa-pencil-square-o', label: 'Correzione' },
    { to: '/consultazione', icon: 'fa-search', label: 'Consultazione' },
];

const HomePage = () => {
    const navigate = useNavigate();
    const info = new employee().getUserInfo() || {};
    const name = [info.surname, info.name].filter(Boolean).join(' ');

    return (
        <div className="pkg-page">
            <div className="home-welcome">
                Operatore: <strong>{name || '—'}</strong>{info.qualifica_label ? ` · ${info.qualifica_label}` : ''}
            </div>
            <div className="home-grid">
                {TILES.map(t => (
                    <div key={t.to} className="home-tile" onClick={() => navigate(t.to)}>
                        <i className={`fa ${t.icon}`} aria-hidden="true"></i>
                        <span>{t.label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HomePage;
